export const DATA = 'DATA';
export const SECTION_HEADER = 'SECTION_HEADER';
export const COLUMN_HEADER = 'COLUMN_HEADER';
export const PARENT_DATA = 'PARENT_DATA';
export const CHILD_DATA = 'CHILD_DATA';
export const CHILD_DATA_BOLD = 'CHILD_DATA_BOLD';
export const PARENT_SUMMARY = 'PARENT_SUMMARY';
export const PARENT_SUMMARY_DOUBLE = 'PARENT_SUMMARY_DOUBLE';
export const TEXT = 'TEXT';
export const EMPTY = 'EMPTY';

export const DATA_BORDER_TOPLINE = 'DATA_BORDER_TOPLINE';
export const DATA_BORDER_DOUBLEBOTTOMLINE = 'DATA_BORDER_DOUBLEBOTTOMLINE';
export const DATA_BORDER_TOPLINE_DOUBLE_BOTTOMLINE
  = 'DATA_BORDER_TOPLINE_DOUBLE_BOTTOMLINE';

export type RowTypes = 'DATA' | 'SECTION_HEADER' | 'COLUMN_HEADER' | 'PARENT_DATA' | 'CHILD_DATA' | 'CHILD_DATA_BOLD' | 'PARENT_SUMMARY' | 'PARENT_SUMMARY_DOUBLE' | 'TEXT' | 'EMPTY' | 'DATA_BORDER_TOPLINE' | 'DATA_BORDER_DOUBLEBOTTOMLINE' | 'DATA_BORDER_TOPLINE_DOUBLE_BOTTOMLINE' | string;
